import { Color } from './Color';
export class Shadow {
  constructor(shadowData) {
    this.shadowData = shadowData;
  }
  stylesWeb() {
    if (typeof this.shadowData === 'undefined') {
      return {
        boxShadow: 'none'
      };
    }
    var {
      offsetX,
      offsetY,
      blurRadius,
      spreadRadius,
      color
    } = this.shadowData;
    return {
      boxShadow: "".concat(offsetX, "px ").concat(offsetY, "px ").concat(blurRadius, "px ").concat(spreadRadius, "px ").concat(color.toString())
    };
  }
  stylesIos() {
    if (typeof this.shadowData === 'undefined') {
      return {
        shadowOffset: {
          width: 0,
          height: 0
        },
        shadowRadius: 0,
        shadowColor: 'transparent',
        shadowOpacity: 0
      };
    }
    var {
      offsetX,
      offsetY,
      blurRadius,
      spreadRadius,
      color
    } = this.shadowData;
    return {
      shadowOffset: {
        width: offsetX + spreadRadius,
        height: offsetY + spreadRadius
      },
      shadowRadius: blurRadius,
      shadowColor: color.toString(),
      shadowOpacity: 1
    };
  }
  stylesAndroid() {
    if (typeof this.shadowData === 'undefined') {
      return {
        elevation: 0,
        shadowColor: 'transparent'
      };
    }
    var {
      elevation,
      color
    } = this.shadowData;
    var colorArray = color.toArray();
    return {
      elevation,
      shadowColor: new Color([colorArray[0], colorArray[1], colorArray[2], colorArray[3] * 5]).toString()
    };
  }
}
//# sourceMappingURL=Shadow.js.map